import styled from 'styled-components';

export const StyledBox = styled('div')`
  .inner-container {
    padding: 0 !important;
    @media (min-width: ${({ theme }) => theme.breakpoint_lg}) {
      max-width: 440px !important;
    }
  }
`;

export const LinkWrapper = styled.div`
  display: block;
  margin: 0 auto;
  margin-bottom: ${({ theme }) => theme.size_spacing_05 || '1.5rem'};
  max-width: 80%;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.size_spacing_05 || '1.5rem'};
`;
